import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik, Form, ErrorMessage } from "formik";
import Button from "../../../atoms/buttons/Button";
import Modal from "react-bootstrap/Modal";
import "./consultaNominas.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../../atoms/spinner/Spinner";
import { getYears } from "../../../services/NominasService";
import { useNavigate } from "react-router-dom";
// import PDF_GUIA_RECIBO_SARIAL from "../../../../resources/pdf/nominas/GUIA_Recibo_Salarial_2019.pdf";
import SubTituloResMini from "../../../atoms/subTitles/SubTituloResMini";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ButtonCard from "../../../atoms/buttons/ButtonCard";
registerLocale("es", es);

const ConsultaNominas = (object) => {
  const [user] = useLocalStorage("user", "");

  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(true);
  const [months, setMonths] = useState([]);
  const [years] = useState([]);
  const [selected, setSelected] = useState({
    year: null,
    month: null,
  });
  const [intervalos] = useState([]);
  const [mensaje, setMensaje] = useState();
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);
  const meses = [
    "",
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  // const pdfGuia = () => {
  //   window.open(PDF_GUIA_RECIBO_SARIAL);
  // };

  // const handleChangeSelect = (e, name) => {
  //   setShowFeedback(false);

  //   setSelected((prevState) => ({
  //     ...prevState,
  //     [name]: e?.value,
  //   }));
  //   if (name === "year" && e) {
  //     setMonths(intervalos[years.indexOf(e)].mes);
  //   } else if (name === "year" && (e === null || e === undefined)) {
  //     selected.month = undefined;
  //   }

 
  // };

  const handleChangeSelect = (e, name) => {
    setShowFeedback(false);

    if (name === "year") {
      if (e) {
        const yearIndex = years.findIndex((y) => y.value === e.value);
        const mesesDisponibles = intervalos[yearIndex]?.mes || [];

        // 🔹 Reiniciar mes ANTES de actualizar los meses disponibles
        setSelected({ year: e.value, month: null });

        // 🔹 Cargar meses del nuevo año
        setMonths(mesesDisponibles);
      } else {
        // 🔹 Si se borra el año, reiniciar todo
        setSelected({ year: null, month: null });
        setMonths([]);
      }
    }

    if (name === "month") {
      // 🔹 Solo cambiar el mes si existe año seleccionado
      if (selected.year) {
        setSelected((prev) => ({
          ...prev,
          month: e ? e.value : null,
        }));
      }
    }
  };




  useEffect(() => {
    getYears(user?.accessToken).then((data) => {
      
      if (!data.toString().startsWith("Error:")) {
        if (years.length === 0) {
          for (let i = 0; i < data.length; i++) {
            years.push({
              label: data[i].anyo.label,
              value: data[i].anyo.value,
            });
            intervalos.push(data[i]);
            setSelected({
              year: intervalos[intervalos.length - 1].anyo.value,
              month:
                intervalos[intervalos.length - 1].mes[
                  intervalos[intervalos.length - 1].mes.length - 1
                ].value,
            });
            setMonths(intervalos[intervalos.length - 1].mes);
          }
        }
        setLoading(true);
      } else {
        setMensaje(data);
      }
    });
  }, [intervalos, years, selected, user?.accessToken]);

  function modalConsultaNominas() {
    return (
      <Modal
        className="infModal fechas"
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Consulta Nóminas"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Consulta Nóminas</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            <Formik
              initialValues={{
                month: 0,
                year: 0,
              }}
              validate={(valores) => {
                valores.month = selected.month;
                valores.year = selected.year;
                const errores = {};

                if (!valores.year) {
                  errores.year = "Debe seleccionar un año";
                } else if (!valores.month) {
                  errores.month = "Debe seleccionar un mes";
                } else if (!months.some((m) => m.value === valores.month)) {
                  errores.month = `El mes seleccionado no está disponible para el año ${valores.year}`;
                }

                return errores;
              }}
              onSubmit={(valores) => {
           
                setLoadingButton(false);
                if (parseInt(valores.year) <= 2007) {
                  object.handleClose(true);
                  navigate("/nomina", {
                    state: { id: 1, year: valores.year, month: valores.month },
                  });
                  setShowFeedback(false);
                  setLoadingButton(true);
                } else {
                  //pasar a preview
                  // getPDF(valores.year, valores.month).then((data) => {
                  //   if (!data.toString().startsWith("Error:")) {
                  //     const file = new Blob([data], {
                  //       type: "application/pdf",
                  //     });
                  //     if (file.size !== 0) {
                  //       const fileURL = URL.createObjectURL(file);
                  //       const link = document.createElement("a");
                  //       link.href = fileURL;
                  //       link.download = `NOM_${valores.year}_${valores.month}.pdf`;
                  //       link.click();
                  //       link.remove();
                  //       setLoadingButton(true);
                  //       setShowFeedback(false);
                  //     } else {
                  //       setLoadingButton(true);
                  //       setShowFeedback(true);
                  //     }
                  //   } else {
                  //     setLoadingButton(true);
                  //     setShowFeedback(true);
                  //   }
                  // });
                  const mesSeleccionado = months.find((m) => m.value === valores.month);
                  localStorage.setItem("datosNominaSelect", JSON.stringify({ anyo: valores.year, mes: valores.month, nombreMes: mesSeleccionado ? mesSeleccionado.label : "" }))

                  navigate(`/nominaPDF`);
                  object.handleClose();
                }
              }}
            >
              {({ errors }) => (
                <>
                  <Form>
                    <div className="container">

                      <div className="row justify-content-center">
                        {loading ? (
                          <>
                            {/* Select año + ERROR */}
                            <div className="row col-xxl-4 col-xl-3 col-lg-3 cold-md-3 cold-sm-3 pb-2 ">
                              <label htmlFor="year">
                                <SubTituloResMini nombre="Año"></SubTituloResMini>
                              </label>
                              <Select
                                id="year"
                                name="year"
                                options={years}
                                className="selectYear"
                                onChange={(e) => {
                                  handleChangeSelect(e, "year");
                                }}
                                placeholder={"Año"}
                                defaultValue={years[years.length - 1]}
                                isClearable
                              />
                            </div>

                            {/* Select Mes + ERROR */}
                            <div className="row col-xxl-4 col-xl-3 col-lg-3 cold-md-3 cold-sm-3 pb-2 ">
                              <label htmlFor="month">
                                <SubTituloResMini nombre="Mes"></SubTituloResMini>
                              </label>
                              <Select
                                id="month"
                                name="month"
                                options={months}
                                className="selectMonth"
                                onChange={(e) => handleChangeSelect(e, "month")}
                                placeholder="Mes"
                                isDisabled={!selected?.year}
                                isClearable
                                // ✅ valor controlado
                                value={
                                  months.find((m) => m.value === selected.month)
                                    ? months.find((m) => m.value === selected.month)
                                    : null
                                }
                              />

                            </div>
                            <div className="mensajes">

                              {(errors.year && !selected?.year) ? (
                                <>
                                  <ErrorMessage
                                    name="year"
                                    component={() => (
                                      <div className="error rojo fs-4">
                                        {errors.year}
                                      </div>
                                    )}
                                  />
                                </>
                              ) : null}

                              {(errors.month) ? (<>
                                <ErrorMessage
                                  name="month"
                                  component={() => (
                                    <div className="error rojo fs-4">
                                      {errors.month}
                                    </div>
                                  )}
                                /></>) : null}
                            </div>
                            <div className="col-xl-3">
                              <ButtonCard
                                id="consultaNomina"
                                clases="btn-card rounded btn-modal-nominas"
                                nombre={
                                  loadingButton ? (
                                    <><i className="fa-solid fa-eye"></i> Consultar</>
                                  ) : (
                                    <>
                                      <div className="d-flex justify-content-center">
                                        <SpinnerCircleMini
                                          clases={"background-border"}
                                        ></SpinnerCircleMini>
                                      </div>
                                    </>
                                  )
                                }
                                tipo="submit"
                                disabled={!loadingButton}
                              />
                            </div>



                            {showFeedback ? (
                              <>
                                <div className="error rojo fs-4 pt-2">
                                  {`Error al cargar el PDF del año ${selected.year
                                    } y del mes de ${meses[selected.month]}`}
                                </div>
                              </>
                            ) : null}






                            {/* <i className="fa-solid fa-caret-right my-2">
                              {" "}
                              <Link
                                to={""}
                                className="pt-1 fw-light"
                                onClick={pdfGuia}
                                alt="Se abre en ventana nueva"
                                role="link"
                                title="Enlace PDF"
                                aria-label="Enlace PDF"
                              >
                                Guía del recibo individual de salarios
                              </Link>
                            </i> */}
                          </>
                        ) : (
                          <>
                            <span>
                              {mensaje === undefined ? <SpinnerCircle /> : null}
                            </span>
                            <div className="error rojo fs-4 pt-2">
                              {mensaje !== undefined ? mensaje : null}
                            </div>
                            {mensaje !== undefined ? (
                              <>
                                <div className="row justify-content-center pt-3">
                                  <Button
                                    id="btnCerrarConsultaIRPF"
                                    clases="btn-card"
                                    nombre="Cerrar"
                                    tipo="button"
                                    funcion={() => {
                                      object.handleClose();
                                    }}
                                  />
                                </div>
                              </>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalConsultaNominas()}</>;
};

export default memo(ConsultaNominas);
